import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { datacontext } from 'modules/AppLayout/AppLayout';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { postApiCall, dateformatBasedOnUserType } from 'api/apiService';
import { POST_VENDOR_BANNER_PRIVATE_OFFER } from 'constant/app.config';
import GeneratePdfDialog from 'component/VendorGeneratePdf';
import AcceptanceCertificateDialog from 'modules/private/AgentDashboard/AcceptanceCertificateDialog';

const YellowWarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F39800"
      />
    </svg>
  );
};

const EyeIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.875 9.5C11.875 10.1299 11.6248 10.734 11.1794 11.1794C10.734 11.6248 10.1299 11.875 9.5 11.875C8.87011 11.875 8.26602 11.6248 7.82062 11.1794C7.37522 10.734 7.125 10.1299 7.125 9.5C7.125 8.87011 7.37522 8.26602 7.82062 7.82062C8.26602 7.37522 8.87011 7.125 9.5 7.125C10.1299 7.125 10.734 7.37522 11.1794 7.82062C11.6248 8.26602 11.875 8.87011 11.875 9.5Z"
        fill="#4A88FD"
      />
      <path
        d="M17.3349 9.14678C15.6265 5.72915 12.5928 3.95898 9.50218 3.95898C6.41231 3.95898 3.37785 5.72915 1.66943 9.14678C1.61452 9.25666 1.58594 9.37781 1.58594 9.50065C1.58594 9.62349 1.61452 9.74464 1.66943 9.85453C3.37785 13.2722 6.41151 15.0423 9.50218 15.0423C12.5921 15.0423 15.6265 13.2722 17.3349 9.85453C17.3898 9.74464 17.4184 9.62349 17.4184 9.50065C17.4184 9.37781 17.3898 9.25666 17.3349 9.14678ZM9.50218 13.459C7.15172 13.459 4.7506 12.1765 3.27176 9.50065C4.7506 6.82482 7.15093 5.54232 9.50218 5.54232C11.8526 5.54232 14.2538 6.82482 15.7326 9.50065C14.2538 12.1765 11.8526 13.459 9.50218 13.459Z"
        fill="#4A88FD"
      />
    </svg>
  );
};

const Sign = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_37216_88626)">
        <path
          d="M2.375 13.4583C5.01363 10.8197 6.33333 8.70833 6.33333 7.125C6.33333 4.75 5.54167 4.75 4.75 4.75C3.95833 4.75 3.14133 5.60896 3.16667 7.125C3.19358 8.74633 4.47925 10.986 5.14583 11.875C6.33333 13.4583 7.125 13.8542 7.91667 12.6667L9.5 10.2917C9.76363 12.403 10.5553 13.4583 11.875 13.4583C12.2946 13.4583 13.9642 11.875 14.25 11.875C14.6593 11.875 15.451 12.403 16.625 13.4583"
          stroke="#62CB4C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_37216_88626">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const PrivateOfferConfirmationPopup = ({
  open,
  onClose,
  privateOfferDetails,
  propertyAddress,
  profileDetails,
  logData,
  getListInfo,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const history = useHistory();

  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);

  const userID = userDetail?.userId;
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  const ownerDetails = profileDetails?.PropertyDetails?.propertyOwnerDetails;
  const getPrimaryOwner = ownerDetails?.some(
    (val) => val.isPrimary === 1 && val?.user?.userId == userID
  );

  const DateTimeDisplay = ({ dateTimeStr }) => {
    const date = new Date(dateTimeStr);
    const hours24 = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours24 >= 12 ? 'pm' : 'am';
    const hours12 = hours24 % 12 || 12;
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return (
      <div>{`${hours12}.${minutes}${ampm} - ${day}-${month}-${year}`}</div>
    );
  };

  const [openEsign, setOpenEsign] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleSubmit = () => {
    // 👉 If signed, open PDF popup
    if (
      privateOfferDetails?.isSigned === 1 &&
      privateOfferDetails?.signedFile
    ) {
      setOpenPdf(true);
      return;
    }

    // existing behaviour (unchanged)
    onClose();
    setOpenEsign(true);
  };

  const propertyId = profileDetails?.PropertyDetails?.property?.propertyId;
  const agentId = profileDetails?.PropertyDetails?.agentDetails?.agentId;
  const timeoutRef = useRef(null);

  const PrivateOfferReceived =
    profileDetails?.PropertyDetails?.privateOfferDetails?.isSigned == 0 &&
    profileDetails?.PropertyDetails?.privateOfferDetails
      ?.isTodayPrivateViewed == 0;

  const handlePrivateOfferView = async () => {
    let input = {
      propertyId: propertyId,
      agentId: agentId,
    };

    try {
      // setViewLoader(true);
      const response = await postApiCall(
        POST_VENDOR_BANNER_PRIVATE_OFFER,
        input
      );
      if (response?.data?.status == 1) {
        await getListInfo('privateOffer', propertyId);
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
      // } finally {
      //   setViewLoader(false);
    }
  };

  useEffect(() => {
    if (open && PrivateOfferReceived) {
      timeoutRef.current = setTimeout(() => {
        handlePrivateOfferView();
      }, 10000);
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [open, PrivateOfferReceived]);

  return (
    <>
      <Dialog
        open={open}
        fullScreen={matchessm}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            borderRadius: matchessm ? 0 : '5px',
            width: matchessm ? '100%' : matches800 ? '95%' : '800px',
            maxWidth: matchessm ? '100%' : '800px',
            height: matchessm ? '100%' : 'auto',
            margin: matchessm ? 0 : '32px',
            padding: matchessm ? '20px 16px' : '30px',
            boxShadow: matchessm ? 'none' : '-4px 4px rgba(0, 0, 0, 0.09)',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: ' Poppins',
                fontWeight: 400,
                fontSize: matchessm ? '12px' : '14px',
              }}
            >
              {propertyAddress}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 2,
                alignItems: 'center',
              }}
            >
              <YellowWarning />
              <Typography
                sx={{
                  fontFamily: ' Poppins',
                  fontWeight: 500,
                  fontSize: matchessm ? '20px' : '24px',
                }}
              >
                Private Offer Details
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: ' Poppins',
                fontWeight: 400,
                fontSize: matchessm ? '14px' : '16px',
              }}
            >
              Your agent has prepared a Private Offer for your acceptance. Once
              accepted, it will be used as a tool to motivate buyers to increase
              their offers.
            </Typography>
          </Grid>
          <Divider color="red" />
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
              grid: 2,
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
                paddingY: '15px',
                alignContent: 'right',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: matchessm ? '10px' : '12px',
                  fontWeight: '400',
                  color: '#AEAEAE',
                  alignItems: 'right',
                }}
              >
                {dateformatBasedOnUserType(
                  privateOfferDetails?.offerCreatedAt,
                  primaryUserTypeValue
                )}
                {/* <DateTimeDisplay
                dateTimeStr={privateOfferDetails?.offerCreatedAt}
              /> */}
              </Typography>
            </Box>

            <Stack direction={'column'} gap={6}>
              <Typography
                sx={{
                  fontSize: matchessm ? '20px' : '24px',
                  fontFamily: 'poppins',
                  fontWeight: 400,
                }}
              >
                Prepared Private Offer
              </Typography>

              <Stack direction={'row'}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    color: '#666666',
                    width: '35%',
                  }}
                >
                  Your status:
                </Typography>

                {privateOfferDetails?.isSigned === 1 ||
                privateOfferDetails?.vendorStatus === 'Viewed' ? (
                  <Stack
                    direction={'row'}
                    alignItems="center"
                    spacing={1}
                    sx={{
                      borderRadius: '15px',
                      backgroundColor:
                        privateOfferDetails?.isSigned === 1
                          ? '#CEFECE'
                          : '#EBF1FF',
                      padding: '4px 8px',
                      minHeight: '32px',
                      width: 'fit-content',
                    }}
                  >
                    {privateOfferDetails?.isSigned === 1 ? (
                      <Sign sx={{ color: '#3FBA20' }} />
                    ) : (
                      <EyeIcon sx={{ color: '#4A88FD' }} />
                    )}
                    <Typography
                      sx={{
                        fontSize: matchessm ? '14px' : '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color:
                          privateOfferDetails?.isSigned === 1
                            ? '#3FBA20'
                            : '#4A88FD',
                      }}
                    >
                      {privateOfferDetails?.isSigned === 1
                        ? 'Signed'
                        : 'Viewed'}
                    </Typography>
                  </Stack>
                ) : (
                  <Stack
                    direction={'row'}
                    alignItems="center"
                    spacing={1}
                    sx={{
                      borderRadius: '15px',
                      backgroundColor: '#F398001A',
                      padding: '4px 8px',
                      minHeight: '32px',
                      width: 'fit-content',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: matchessm ? '14px' : '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: '#F39800',
                      }}
                    >
                      Pending
                    </Typography>
                  </Stack>
                )}
                <Stack
                  direction={'row'}
                  alignItems="center"
                  spacing={1}
                  sx={{
                    borderRadius: '15px',
                    // backgroundColor: '#F398001A',
                    padding: '4px 8px',
                    minHeight: '32px',
                    width: 'fit-content',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'Poppins',
                      fontWeight: 500,
                      color: '#AEAEAE',
                    }}
                  >
                    {privateOfferDetails?.signedAt
                      ? (() => {
                          const date = new Date(
                            privateOfferDetails.signedAt.replace(' ', 'T')
                          );

                          const time = date.toLocaleTimeString('en-GB', {
                            hour: '2-digit',
                            minute: '2-digit',
                          });

                          const formattedDate = date
                            .toLocaleDateString('en-GB')
                            .replace(/\//g, '-');

                          return `${time} ${formattedDate}`;
                        })()
                      : ''}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction={'row'}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    color: '#666666',
                    width: '35%',
                  }}
                >
                  Price:
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 500,
                    color: '#000000',
                    width: '40%',
                  }}
                >
                  {privateOfferDetails?.privateOfferPrice}
                </Typography>
              </Stack>

              <Stack direction={'row'}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    color: '#666666',
                    width: '35%',
                  }}
                >
                  Offer Status:
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '10px',
                    width: 'auto',
                  }}
                >
                  <Typography
                    sx={{
                      display: 'flex',
                      width: '95px',
                      padding: '3px 6px',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                      gap: '10px',
                      borderRadius: '5px',
                      background:
                        privateOfferDetails?.isConditional == 1
                          ? 'rgba(237, 11, 11, 0.60)'
                          : '#10D35E',
                      marginTop: '-2px',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontFamily: 'Poppins',
                        fontSize: '10px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: 'normal',
                        textTransform: 'capitalize',
                      }}
                    >
                      {privateOfferDetails?.isConditional == 1
                        ? 'Conditional'
                        : 'Unconditional'}
                    </Typography>
                  </Typography>
                </Box>
              </Stack>
              <Stack direction={'row'}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    color: '#666666',
                    width: '35%',
                  }}
                >
                  Deposit:
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 500,
                    color: '#000000',
                    width: '40%',
                  }}
                >
                  {privateOfferDetails?.depositAmount}%
                </Typography>
              </Stack>
              <Stack direction={'row'}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    color: '#666666',
                    width: '35%',
                  }}
                >
                  Settlement:
                </Typography>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 500,
                    color: '#000000',
                    width: '40%',
                  }}
                >
                  {privateOfferDetails?.settlementDays
                    ? `${privateOfferDetails.settlementDays} ${
                        Number(privateOfferDetails.settlementDays) === 1
                          ? 'day'
                          : 'days'
                      }`
                    : '-'}
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction={'column'}
              gap={3}
              marginY={matchessm ? '15px' : '40px'}
            >
              <Typography
                sx={{
                  fontSize: matchessm ? '14px' : '18px',
                  fontFamily: 'poppins',
                  fontWeight: 400,
                }}
              >
                Agent's Comments
              </Typography>

              <Box sx={{ backgroundColor: '#F6F6F6', padding: '30px' }}>
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '18px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word', // Forces breaking of long words
                  }}
                >
                  {privateOfferDetails?.messageToVendor}
                </Typography>
              </Box>

              {privateOfferDetails?.isSigned !== 1 && (
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '18px',
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    color: '#666666',
                    marginY: matchessm ? '10px' : '30px',
                  }}
                >
                  By clicking Next, you will be prompted to sign. Once signed,
                  you agree to sell to any buyer who matches or exceeds the
                  accepted Private Offer price.
                </Typography>
              )}
            </Stack>

            <Stack direction={'row'} justifyContent={'flex-end'}></Stack>
          </Grid>
          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'space-between' : 'flex-end'}
            gap={!getPrimaryOwner ? '0' : matchessm ? 1 : 2}
            marginBottom={'30px'}
            marginRight={matchessm ? '0px' : '30px'}
          >
            <Button
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '130px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '15px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
              }}
              onClick={() => {
                getListInfo('privateOffer', propertyId);
                onClose();
                history.replace({
                  pathname: location.pathname,
                  state: {},
                });
              }}
            >
              {privateOfferDetails?.isSigned === 1 ? 'Close' : 'Cancel'}
            </Button>
            {/* {
            getPrimaryOwner && (
          <Button
            variant="outlined"
            onClick={handleSubmit}
            style={{
              padding: matchessm ? "6px 23px" : "10px 39px",
              width: "130px",
              height: matchessm ? "35px" : "41px",
              fontSize: matchessm ? "12px" : "15px",
              color: "#FFFFFF",
              fontWeight: "400",
              fontFamily: "Poppins",
              background: "#4CA4D6",
              borderRadius: "5px",
              textTransform: "none",
              opacity: 1,
            }}
          >
            {privateOfferDetails?.isSigned === 1 ? "View" : "Next"}
          </Button>
            )
          } */}

            {getPrimaryOwner &&
              !(
                profileDetails?.PropertyDetails?.stage === 'ST2' &&
                privateOfferDetails?.isSigned !== 1
              ) && (
                <Button
                  variant="outlined"
                  disabled={
                    privateOfferDetails?.isSigned !== 1 &&
                    (profileDetails?.PropertyDetails?.timerStatus === 'Pause' ||
                      profileDetails?.PropertyDetails?.timerStatus === 'End')
                  }
                  onClick={async () => {
                    clearTimeout(timeoutRef.current);

                    if (
                      privateOfferDetails?.isSigned != 1 &&
                      PrivateOfferReceived
                    ) {
                      await handlePrivateOfferView();
                    }

                    handleSubmit();
                  }}
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '130px',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '15px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'none',
                    opacity:
                      privateOfferDetails?.isSigned !== 1 &&
                      (profileDetails?.PropertyDetails?.timerStatus ===
                        'Pause' ||
                        profileDetails?.PropertyDetails?.timerStatus === 'End')
                        ? 0.5
                        : 1,
                  }}
                >
                  {privateOfferDetails?.isSigned === 1 ? 'View' : 'Next'}
                </Button>
              )}
          </Grid>
        </Grid>
      </Dialog>

      <AcceptanceCertificateDialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        profileDetails={profileDetails}
        vendorHistoryData={[{ signedFile: privateOfferDetails?.signedFile }]}
        selectedRowIndex={0}
      />

      <GeneratePdfDialog
        open={openEsign}
        onClose={() => setOpenEsign(false)}
        propertyId={propertyId}
        buyerId={0}
        offerUniqueId={privateOfferDetails?.id}
        status={'Private Offer'}
        address={propertyAddress}
        getListInfo={getListInfo}
        confirmLoading={confirmLoading}
        setConfirmLoading={setConfirmLoading}
      />
    </>
  );
};

export default PrivateOfferConfirmationPopup;
